var Component = require("!../../../../../../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  null,
  /* template */
  require("!!../../../../../../../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-409e8c79\",\"hasScoped\":false,\"preserveWhitespace\":false}!../../../../../../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./MentoringGirlIcon.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/profile/modules/mentoring/components/avatar/components/stub/components/girl/MentoringGirlIcon.vue
// module id = bf6cf7646c94045b8087
// module chunks = 89